<template>
  <div class="wx-jqr">
    <div class="user-list" v-if="$store.state.store_id==1780 || $store.state.store_id==1989">
      <div class="user-item" 
           v-for="user in userList" 
           :key="user.id"
           :class="{ active: settings && settings.id === user.id, 'new-user': user.isNew }"
           @click="selectUser(user)">
        <div class="avatar-container">
         
          <el-avatar :src="formatAvatarUrl(user.gewe_avatar || user.avatar)" :size="50"></el-avatar>
          <el-button 
            v-if="!user.isNew" 
            class="delete-btn" 
            type="danger" 
            icon="el-icon-close" 
            circle 
            size="mini" 
            @click.stop="deleteUser(user)">
          </el-button>
        </div>
        <div class="user-name">{{ user.gewe_nickname }}</div>
      </div>
    </div>
    
    <div class="settings-form" v-if="settings">
      <h3>{{ settings.isNew ? '新增微信设置' : settings.gewe_nickname + ' 的设置' }} (机器人总次数 {{ settings.set_number }})</h3>
      
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="机器人设置" name="robot" v-if="$store.state.store_id==1780 || $store.state.store_id==1989">
          <el-form :model="settings" label-width="100px" size="mini">
            <!-- 回复模式 -->
            <el-form-item label="回复模式">
              <el-radio-group v-model="settings.reply_mode">
                <el-radio label="text">文字</el-radio>
                <el-radio label="image">图片</el-radio>
              </el-radio-group>
            </el-form-item>
            
            <!-- 套餐设置 -->
            <el-form-item label="套餐设置">
              <el-radio-group v-model="settings.set_meal">
                <el-radio label="lCount">周期次数模式</el-radio>
                <el-radio label="count">次数模式</el-radio>
              </el-radio-group>
            </el-form-item>
            
            <!-- 机器人模式设置 -->
            <div v-if="settings.set_meal === 'lCount'" class="package-settings">
              <el-form-item label="每天次数">
                <el-input-number v-model="settings.set_number" :min="1"></el-input-number>
                <span>次</span>
              </el-form-item>
              <el-form-item label="周期时间">
                <el-date-picker
                  v-model="settings.cycleTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="timestamp">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="已使用次数">
                <el-input-number v-model="settings.set_surplus" :min="0"></el-input-number>
                <span>次</span>
              </el-form-item>
            </div>
            
            <!-- 按次数模式设置 -->
            <div v-if="settings.set_meal === 'count'" class="package-settings">
              <el-form-item label="总次数">
                <el-input-number v-model="settings.set_number" :min="1"></el-input-number>
                <span>次</span>
              </el-form-item>
              <el-form-item label="已使用次数">
                <el-input-number v-model="settings.set_surplus" :min="0"></el-input-number>
                <span>次</span>
              </el-form-item>
            </div>
            
          
            <!-- 库存报出 -->
            <el-form-item label="库存报出">
              <el-radio-group v-model="settings.inventory_report">
                <el-radio label="1">可报</el-radio>
                <el-radio label="0">不可报</el-radio>
              </el-radio-group>
            </el-form-item>
            
            <!-- 广告语设置 -->
            <el-form-item label="广告语">
              <el-input 
                type="textarea" 
                v-model="settings.reply_ad" 
                placeholder="请输入广告语"
                :rows="3"
                maxlength="200"
                show-word-limit
                style="width: 350px;">
              </el-input>
            </el-form-item>
            
            <!-- Token设置 -->
            <el-form-item label="Token">
              <el-input 
                v-model="settings.gewe_token" 
                placeholder="请输入Token"
                show-password
                style="width: 350px;">
              </el-input>
            </el-form-item>
            
            <!-- AppId设置 -->
            <el-form-item label="AppId">
              <el-input 
                v-model="settings.gewe_device_id" 
                placeholder="请输入设备id"
                style="width: 350px;">
              </el-input>
            </el-form-item>
            
            <!-- 消息间隔 -->
            <el-form-item label="上下文间隔">
              <el-select v-model="settings.reply_time" placeholder="请选择消息间隔">
                <el-option label="1秒" value="1"></el-option>
                <el-option label="5秒" value="5"></el-option>
                <el-option label="10秒" value="10"></el-option>
                <el-option label="30秒" value="30"></el-option>
                <el-option label="60秒" value="60"></el-option>
                <el-option label="120秒" value="120"></el-option>
                <el-option label="十分钟" value="600"></el-option>
                <el-option label="一小时" value="3600"></el-option>
              </el-select>
              
            </el-form-item>
            
            <!-- 指定关联客户 -->
            <el-form-item label="关联客户">
              <el-select
                v-model="selectedCustomerId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词搜索客户"
                :remote-method="fetchCustomers"
                :loading="customersLoading"
                @change="handleCustomerChange"
                >
                <el-option
                  v-for="item in customers"
                  :key="item.store_id"
                  :label="item.company_name"
                  :value="item.store_id">
                  <span style="float: left">{{ item.company_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ item.store_id }}</span>
                </el-option>
              </el-select>
              <div v-if="selectedCustomerDisplay" class="selected-customer">
                已选择: {{ selectedCustomerDisplay.company_name }} (ID: {{ selectedCustomerDisplay.store_id }})
              </div>
            </el-form-item>

            <!-- 指定关联客户账户信息 -->
            <el-form-item label="关联员工" v-if="selectedCustomerId">
              <el-select 
                v-model="selectedEmployeeId" 
                filterable 
                remote 
                reserve-keyword
                :remote-method="fetchEmployees"
                :loading="employeesLoading"
                placeholder="请输入关键词搜索员工"
                @change="handleEmployeeChange"
                >
                <el-option
                  v-for="employee in employees"
                  :key="employee.account_id"
                  :label="employee.nickname"
                  :value="employee.account_id">
                  <span style="float: left">{{ employee.nickname }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ employee.account_id }}</span>
                </el-option>
              </el-select>
              <div v-if="selectedEmployeeDisplay" class="selected-employee">
                已选择: {{ selectedEmployeeDisplay.nickname }} (ID: {{ selectedEmployeeDisplay.account_id }})
              </div>
            </el-form-item>
            
            <!-- 指定店铺配件ID -->
            <el-form-item label="配件店铺id">
              <el-select
                v-model="selectedShopPartId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词搜索店铺配件"
                :remote-method="fetchShopParts"
                :loading="shopPartsLoading"
                >
                <el-option
                  v-for="item in shopParts"
                  :key="item.store_id"
                  :label="item.company_name"
                  :value="item.store_id">
                  <span style="float: left">{{ item.company_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ item.store_id }}</span>
                </el-option>
              </el-select>
              <div v-if="selectedShopPartDisplay" class="selected-shop-part">
                已选择: {{ selectedShopPartDisplay.company_name }} (ID: {{ selectedShopPartDisplay.store_id }})
              </div>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" @click="saveSettings">{{ settings.isNew ? '新增' : '提交' }}</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        
        <el-tab-pane label="群聊设置" name="groupChats">
          <div v-if="!groupChatDetails.length" class="no-data">
            暂无群聊数据
          </div>
          <div v-else>
            <div class="group-chat-list">
              <div 
                v-for="group in filteredGroupChatDetails" 
                :key="group.wxid"
                class="group-chat-item"
                :class="{ active: selectedGroupChat && selectedGroupChat.chatroom_id === group.chatroom_id }"
                @click="selectGroupChat(group)"
              >
                <el-avatar :src="group.smallHeadImgUrl" :size="40"></el-avatar>
                <div class="group-info">
                  <div class="group-name">{{ group.remark || group.nickName || group.userName || group.wxid }} </div>
                </div>
              </div>
            </div>
            
            <div v-if="selectedGroupChat" class="group-chat-settings">
              <h4> {{ selectedGroupChat.remark || selectedGroupChat.nickName || selectedGroupChat.userName || selectedGroupChat.wxid }} 的设置 </h4>
              <el-form :model="selectedGroupChat" label-width="100px" size="mini">
                <!-- 次数设置 -->
                <div v-if="settings.set_meal === 'lCount'" class="package-settings">
                  <el-form-item label="每天次数">
                    <el-input-number v-model="selectedGroupChat.set_number" :min="1"></el-input-number>
                    <span>次</span>
                  </el-form-item>
                  <!-- <el-form-item label="周期时间">
                    <el-date-picker
                      v-model="selectedGroupChat.cycleTimeRange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="timestamp">
                    </el-date-picker>
                  </el-form-item> -->

                  <el-form-item label="已使用次数">
                    <el-input-number :disabled="$store.state.store_id!=1780"  v-model="selectedGroupChat.set_surplus" :min="0"></el-input-number>
                    <span>次</span>
                  </el-form-item>
                </div>
                
                <!-- 按次数模式设置 -->
                <div v-if="settings.set_meal === 'count'" class="package-settings">
                  <el-form-item label="总次数">
                    <el-input-number v-model="selectedGroupChat.set_number" :min="1"></el-input-number>
                    <span>次</span>
                  </el-form-item>
                  <!-- 1 -->
                  <el-form-item label="已使用次数">
                    <el-input-number :disabled="$store.state.store_id!=1780" v-model="selectedGroupChat.set_surplus" :min="0"></el-input-number>
                    <span>次</span>
                  </el-form-item>
                  
                </div>
                <!-- 回复模式 -->
                
                <el-form-item label="回复模式">
                  <el-radio-group v-model="selectedGroupChat.reply_mode">
                    <el-radio label="text">文字</el-radio>
                    <el-radio label="image">图片</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="生成短链">
                  <el-radio-group v-model="selectedGroupChat.is_h5_short_url">
                    <el-radio label="1">生成</el-radio>
                    <el-radio label="0">不生成</el-radio>
                  </el-radio-group>
                </el-form-item>
                
                <!-- 价格模式 -->
                <el-form-item label="价格模式">
                  <el-radio-group v-model="selectedGroupChat.is_last_price">
                    <el-radio label="0">加价</el-radio>
                    <el-radio label="1">历史</el-radio>
                    <el-radio label="2">不显示</el-radio>
                    <el-radio label="3">指定价格</el-radio>
                  </el-radio-group>
                </el-form-item>
                
                <!-- 主体名称 -->
                <el-form-item label="主体名称" v-if="selectedGroupChat.is_last_price ==1 ">
                  <el-input 
                    v-model="selectedGroupChat.subjectName" 
                    placeholder="请输入主体名称"
                    style="width: 200px;">
                  </el-input>
                </el-form-item>
                
                <!-- 客户名称 -->
                <el-form-item label="客户名称" v-if="selectedGroupChat.is_last_price ==1">
                  <el-input 
                    v-model="selectedGroupChat.customerName" 
                    placeholder="请输入客户名称"
                    style="width: 200px;">
                  </el-input>
                </el-form-item>
                
                <!-- 加价系数 -->
                <el-form-item label="加价系数" v-if="selectedGroupChat.is_last_price ==0">
                  <el-input-number 
                    v-model="selectedGroupChat.price_roi" 
                    :min="0" 
                    :step="0.1" 
                    controls-position="right"
                    style="width: 120px;">
                    <template slot="append">%</template>
                  </el-input-number>
                </el-form-item> 
                <el-form-item label="指定价" v-if="selectedGroupChat.is_last_price ==3">
                    <el-select
                      v-model="selectedGroupChat.price_field"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="选择指定字段"
                      >
                      <el-option
                        v-for="item in strategyList"
                        :key="item.id"
                        :label="item.price_name"
                        :value="item.price_field">
                        <span style="float: left">{{ item.price_name }}</span>
                        <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.price_field }}</span> -->
                      </el-option>
                    </el-select>
                </el-form-item>               
                <!-- 库存报出 -->
                <el-form-item label="库存报出">
                  <el-radio-group v-model="selectedGroupChat.is_stock">
                    <el-radio label="1">可报</el-radio>
                    <el-radio label="0">不可报</el-radio>
                  </el-radio-group>
                </el-form-item>
                 <el-form-item label="4s价格">
                  <el-radio-group 
                    v-model="selectedGroupChat.is_4s_price"
                  >
                    <el-radio label="1">显示</el-radio>
                    <el-radio label="0">不显示</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- 消息间隔 -->
                <el-form-item label="上下文间隔">
                  <el-select v-model="selectedGroupChat.reply_time" placeholder="请选择消息间隔">
                    <el-option label="1秒" value="1"></el-option>
                    <el-option label="5秒" value="5"></el-option>
                    <el-option label="10秒" value="10"></el-option>
                    <el-option label="30秒" value="30"></el-option>
                    <el-option label="60秒" value="60"></el-option>
                    <el-option label="120秒" value="120"></el-option>
                    <el-option label="十分钟" value="600"></el-option>
                    <el-option label="一小时" value="3600"></el-option>
                  </el-select>
                </el-form-item>
                
                <!-- 主体名称 -->
                <!-- <el-form-item label="主体名称">
                  <el-input 
                    v-model="selectedGroupChat.subjectName" 
                    placeholder="请输入主体名称"
                    style="width: 200px;">
                  </el-input>
                </el-form-item> -->
                
                <!-- 客户名称 -->
                <!-- <el-form-item label="客户名称">
                  <el-input 
                    v-model="selectedGroupChat.customerName" 
                    placeholder="请输入客户名称"
                    style="width: 200px;">
                  </el-input>
                </el-form-item> -->
                
                <!-- 广告语设置 -->
              
                
                <el-form-item>
                  <el-button type="primary" @click="saveGroupChatSettings">保存群聊设置</el-button>
                  <el-button type="danger" @click="deleteGroupChatSettings" v-if="selectedGroupChat && selectedGroupChat.id">删除群聊设置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="次数记录" name="countRecord" v-if="$store.state.store_id==1780 || $store.state.store_id==1989">
          <div class="count-record-list">
            <el-table
              :data="countRecords"
              style="width: 100%"
              v-loading="recordListLoading"
            >
              <el-table-column prop="total" label="总次数" width="120"></el-table-column>
              <el-table-column prop="number" label="已使用次数" width="120"></el-table-column>
              <el-table-column prop="member_name" label="用户名" width="150"></el-table-column>
              <el-table-column prop="time" label="记录时间" width="180">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.time) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      activeTab: 'robot', // 默认显示机器人设置 tab
      userList: [], // 微信列表
      settings: null, // 当前选中的微信设置
      originalSetMeal: null, // 保存原始套餐类型用于比较
      originalSetNumber: null, // 保存原始套餐数量用于比较
      originalSetSurplus: null, // 保存原始已使用次数用于比较
      customers: [], // 客户列表
      selectedCustomerId: null, // 选中的客户ID
      selectedCustomerDisplay: null, // 用于显示的客户信息
      employees: [], // 员工列表
      selectedEmployeeId: null, // 选中的员工ID
      selectedEmployeeDisplay: null, // 用于显示的员工信息
      // 店铺配件相关
      shopParts: [], // 店铺配件列表
      selectedShopPartId: "1780", // 选中的店铺配件ID
      selectedShopPartDisplay: null, // 用于显示的店铺配件信息
      shopPartsLoading: false, // 店铺配件列表加载状态
      customersLoading: false, // 客户列表加载状态
      employeesLoading: false, // 员工列表加载状态
      
      // 群聊相关数据
      groupChatList: [], // 群聊列表
      groupChatDetails: [], // 群聊详细信息
      selectedGroupChat: null, // 选中的群聊
      
      // 次数记录相关数据
      countRecords: [], // 次数记录列表
      recordListLoading: false, // 次数记录列表加载状态
    }
  },
  computed: {
    // 过滤掉 chatroom_id 为 null 的群聊
    filteredGroupChatDetails() {
      return this.groupChatDetails.filter(group => group.chatroom_id !== null);
    }
  },
  methods:{
    // 获取微信列表
    async getUserList(){
      try {
        // 模拟接口调用，后续需要替换成真实接口
        const res = await this.$api.getWxRobots()
        // res[0].children
        console.log("res",res);
        
      
        this.userList = res
        
        // 始终添加一个空用户用于新增
        this.userList.push({
          
          gewe_nickname: '新增微信',
          
          isNew: true, // 标记为新用户
          // 默认设置
          reply_mode: 'text',
          set_meal: 'lCount',
          set_number: "10",
          cycleTimeRange: [],
          reply_ad: '',
          gewe_token: '',
          gewe_device_id: '',
          reply_time: "5",
          markup_coefficient: 0, // 加价系数默认值
          is_last_price: 0, // 价格模式默认值，0加价 1价格
          is_4s_price: 0, // 4s价格默认值，0不显示 1显示
          customerName: '', // 客户名称默认值
          subjectName: '', // 主体名称默认值
          inventory_report: 'reportable', // 库存报出默认值
          set_extend: {
            startTime: null,
            endTime: null
          },
          stat_account: {
            
          }
        })
        
        // 默认选中第一个微信（非新增项）
        if (this.userList.length > 1) {
          this.selectUser(this.userList[0])
        }
      } catch (error) {
        console.error('获取微信列表失败:', error)
        this.$message.error('获取微信列表失败')
      }
    },
    
    // 选择微信
    selectUser(user){
      // 先重置所有相关状态
      this.selectedCustomerId = null;
      this.selectedCustomerDisplay = null;
      this.selectedEmployeeId = null;
      this.selectedEmployeeDisplay = null;
      this.selectedShopPartId = "1780";
      this.selectedShopPartDisplay = null;
      this.customers = [];
      this.employees = [];
      this.shopParts = [];
      this.groupChatList = []; // 清空群聊列表
      this.groupChatDetails = []; // 清空群聊详细信息
      this.selectedGroupChat = null; // 清空选中的群聊
      this.activeTab = 'robot'; // 切换回机器人设置 tab
      
      this.settings = user
      console.log( " this.settings",this.settings);
      
      // 保存原始套餐类型用于比较
      this.originalSetMeal = user.set_meal;
      
      // 保存原始套餐数量和已使用次数用于比较
      this.originalSetNumber = user.set_number;
      this.originalSetSurplus = user.set_surplus;
      
      // 初始化客户和员工信息
      if (user.stat_account) {
        const statAccount = typeof user.stat_account === 'string' 
          ? JSON.parse(user.stat_account) 
          : user.stat_account;
          
        if (statAccount.store_id) {
          this.selectedCustomerId = statAccount.store_id;
          this.selectedCustomerDisplay = {
            store_id: statAccount.store_id,
            company_name: statAccount.store_name || ''
          };
        }
        
        if (statAccount.member_id) {
          this.selectedEmployeeId = statAccount.member_id;
          this.selectedEmployeeDisplay = {
            account_id: statAccount.member_id,
            nickname: statAccount.member_name || ''
          };
        }
        
        // 初始化店铺配件信息
        if (statAccount.shop_id) {
          this.selectedShopPartId = statAccount.shop_id;
          this.selectedShopPartDisplay = {
            store_id: statAccount.shop_id,
            company_name: statAccount.shop_name || ''
          };
        }
      }
      
      // 解析last_price字段
      // if (user.is_last_price != 0 && user.is_last_price != 2 && user.last_price && user.last_price != '0' && user.last_price != '2') {
      //   try {
      //     const lastPriceData = JSON.parse(user.last_price);
      //     this.$set(this.settings, 'customerName', lastPriceData.customerName || '');
      //     this.$set(this.settings, 'subjectName', lastPriceData.subjectName || '');
      //   } catch (e) {
      //     console.error('解析last_price字段失败:', e);
      //   }
      // }
      
      // 如果是周期次数模式，需要初始化周期时间
      if (user.set_meal === 'lCount' && user.set_extend) {
        const setExtend = typeof user.set_extend === 'string' 
          ? JSON.parse(user.set_extend) 
          : user.set_extend;
          
        // 设置周期时间范围
        if (setExtend.startTime && setExtend.endTime) {
          this.$set(this.settings, 'cycleTimeRange', [
            setExtend.startTime,
            setExtend.endTime
          ]);
        } else {
          this.$set(this.settings, 'cycleTimeRange', []);
        }
      }
      
      // 不在选择机器人时获取群聊列表，只在点击群聊设置标签页时获取
      // 获取价格价格字段列表
      this.fetchPriceFields(user);
    },
    async fetchPriceFields(user) {
      try {
        // 调用获取价格字段列表接口
        const res = await this.$api.getPriceStrategy(this.selectedShopPartId);
        console.log("res", res);
        this.strategyList = res;
      } catch (error) {
        console.error('获取价格字段列表失败:', error);
      }
    },
    // 格式化头像URL，解决微信头像无法显示的问题
    formatAvatarUrl(url) {
      if (!url) return url;
      // 如果是微信头像URL且包含/0格式，则替换为/132格式
      if (url.includes('wx.qlogo.cn') && url.endsWith('/0')) {
        return url.replace(/\/0$/, '/132');
      }
      return url;
    },
    
    // 删除用户
    async deleteUser(user) {
      try {
        await this.$confirm('确定要删除该微信账号吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用删除接口
        await this.$api.delWxRobots({ id: user.id });
        
        // 从用户列表中移除
        const index = this.userList.findIndex(item => item.id === user.id);
        if (index > -1) {
          this.userList.splice(index, 1);
        }
        
        // 如果删除的是当前选中的用户，清空设置
        if (this.settings && this.settings.id === user.id) {
          this.settings = null;
        }
        
        this.$message.success('删除成功');
      } catch (error) {

        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },
    
    // 获取客户列表
    async fetchCustomers(query) {
      if (!query) {
        this.customers = [];
        return;
      }
      
      this.customersLoading = true;
      try {
        // 保持原有接口调用形式
        const response = await this.$http("https://api.huanuowei.cn/store/index.php?act=store_manage&op=storeList",{
          company_name: query,
          store_id: 1780,
          joinin_state: "40",
          page: 10,
          curpage: 1
        });
       
        this.customers = response.data  || [];
      } catch (error) {
        console.error('获取客户列表失败:', error);
        this.customers = [];
      } finally {
        this.customersLoading = false;
      }
    },
    
    // 处理客户变更
    handleCustomerChange(customerId) {
      // 清空之前选择的员工
      this.selectedEmployeeId = null;
      this.selectedEmployeeDisplay = null;
      this.employees = [];
      
      if (customerId) {
        // 找到对应的客户信息用于显示
        const customer = this.customers.find(c => c.store_id === customerId);
        if (customer) {
          this.selectedCustomerDisplay = customer;
        }
        // 获取该客户下的员工列表
        this.fetchEmployees('');
      } else {
        this.selectedCustomerDisplay = null;
      }
    },
    
    // 获取员工列表
    async fetchEmployees(query) {
      if (!this.selectedCustomerId) {
        this.employees = [];
        return;
      }
      
      this.employeesLoading = true;
      try {
        // 保持原有接口调用形式
        const response = await this.$http("https://api.huanuowei.cn/store/index.php?act=epc&op=account",{
          store_id: this.selectedCustomerId,
          page: 1,
          limit: 10,
          member_name: query
        });
         console.log("response",response);
        this.employees = response.db || [];
      } catch (error) {
        console.error('获取员工列表失败:', error);
        this.employees = [];
      } finally {
        this.employeesLoading = false;
      }
    },
    
    // 处理员工变更
    handleEmployeeChange(employeeId) {
      if (employeeId) {
        // 找到对应的员工信息用于显示
        const employee = this.employees.find(e => e.account_id === employeeId);
        if (employee) {
          this.selectedEmployeeDisplay = employee;
        }
      } else {
        this.selectedEmployeeDisplay = null;
      }
    },
    
    // 获取店铺配件列表
    async fetchShopParts(query) {
      if (!query) {
        this.shopParts = [];
        return;
      }
      
      this.shopPartsLoading = true;
      try {
        // 使用与获取客户列表相同的接口
        const response = await this.$http("https://api.huanuowei.cn/store/index.php?act=store_manage&op=storeList",{
          company_name: query,
          store_id: 1780,
          joinin_state: "40",
          page: 10,
          curpage: 1
        });
       
        // 确保华诺威(store_id为1780)始终在列表最前面
        let shopPartsData = response.data || [];
        const hnwIndex = shopPartsData.findIndex(item => item.store_id == 1780);
        
        if (hnwIndex > -1) {
          // 如果找到了华诺威，将其移到数组开头
          const hnwItem = shopPartsData.splice(hnwIndex, 1)[0];
          shopPartsData.unshift(hnwItem);
        } else {
          // 如果没有找到华诺威，手动添加
          shopPartsData.unshift({
            store_id: 1780,
            company_name: "华诺威"
          });
        }
        
        this.shopParts = shopPartsData;
      } catch (error) {
        console.error('获取店铺配件列表失败:', error);
        this.shopParts = [];
      } finally {
        this.shopPartsLoading = false;
      }
    },
    
    // 获取群聊列表
    async getGroupChatList() {
     
      if (!this.settings || !this.settings.gewe_token || !this.settings.gewe_device_id) {
        this.groupChatList = [];
        return;
      }
      
      try {
        // 使用指定的接口获取群聊列表，传递 token 和 appId
        const res = await this.$apiGewe.getUserList({
          token: this.settings.gewe_token,
          appId: this.settings.gewe_device_id
        });
        
        this.groupChatList =  res.data.chatrooms
        
        // 获取群聊详细信息
        if (this.groupChatList && this.groupChatList.length > 0) {
          this.groupChatDetails = await this.fetchBatchContactDetails(this.groupChatList, '群聊')
        }
        
        // 如果当前选中的微信有已设置的群聊信息(children)，则与群聊列表关联
        if (this.settings && this.settings.children) {
          // 遍历已设置的群聊信息
          this.settings.children.forEach(child => {
            // 在群聊详细信息中查找对应的群聊
            const groupChat = this.groupChatDetails.find(group => group.chatroom_id === child.room_id);
            if (groupChat) {
              // 解析last_price字段
              let customerName = child.customerName || groupChat.customerName || '';
              let subjectName = child.subjectName || groupChat.subjectName || '';
              
              // 如果is_last_price不为0且last_price是JSON字符串，则解析其中的字段
              if (child.is_last_price&&child.is_last_price.includes('{')) {
                try {
                  const lastPriceData = JSON.parse(child.last_price);
                  customerName = lastPriceData.customerName || customerName;
                  subjectName = lastPriceData.subjectName || subjectName;
                } catch (e) {
                  console.error('解析last_price字段失败:', e);
                }
              }
              
              // 如果找到对应的群聊，将已设置的信息合并到群聊对象中
              Object.assign(groupChat, {
                id: child.id, // 已设置群聊的ID
                price_roi: child.price_roi || groupChat.price_roi || 0,
                price_field: child.price_field || groupChat.price_field || '',
                is_last_price: child.last_price || groupChat.last_price || 0,
                is_4s_price: child.is_4s_price || groupChat.is_4s_price || 0,
                is_h5_short_url: child.is_h5_short_url || groupChat.is_h5_short_url || 0,
                is_stock: child.is_stock || groupChat.is_stock || '1',
                reply_mode: child.reply_mode || groupChat.reply_mode || 'text',
                reply_time: child.reply_time || groupChat.reply_time || "5",
                reply_ad: child.reply_ad || groupChat.reply_ad || '',
                subjectName: subjectName,
                customerName: customerName,
                set_number: child.set_number || groupChat.set_number || 0,
                set_surplus: child.set_surplus || groupChat.set_surplus || 0
              });
            }
          });
        }
      } catch (error) {
        console.error('获取群聊列表失败:', error);
        this.groupChatList = [];
        this.$message.error('获取群聊列表失败');
      }
    },
    
    // 分批获取联系人详细信息（每批不超过20个）
    async fetchBatchContactDetails(wxids, type) {
      let contacts = []
      const batchSize = 20 // 每批最多20
      
      for (let i = 0; i < wxids.length; i += batchSize) {
        const batch = wxids.slice(i, i + batchSize)
        try {
          const res = await this.$apiGewe.getDetailInfo({
            wxids: batch,
            token: this.settings.gewe_token,
            appId: this.settings.gewe_device_id
          })
          
          if (res && res.data) {
            // 处理返回的数据，添加类型标识
            // 修复：正确处理群聊ID，保留原始ID而不是用userName覆盖
            contacts = res.data.map((contact, index) => {
              // console.log("contact",contact);
              
              // 计算在原始wxids数组中的实际索引
              const actualIndex = i + index;
              
              // 解析last_price字段
              let customerName = contact.customerName || '';
              let subjectName = contact.subjectName || '';
              
              // 如果is_last_price不为0且last_price是JSON字符串，则解析其中的字段
              if (contact.is_last_price&&contact.is_last_price.includes('{') ) {
                try {
                  const lastPriceData = JSON.parse(contact.last_price);
                  customerName = lastPriceData.customerName || customerName;
                  subjectName = lastPriceData.subjectName || subjectName;
                } catch (e) {
                  console.error('解析last_price字段失败:', e);
                }
              }
              
              return {
                ...contact,
                type: 'friend',

                // 使用原始的wxid而不是contact.userName
              
                chatroom_id: contact.userName,
                // 添加默认字段值
                price_roi: contact.price_roi || 0,
                price_field: contact.price_field || '',
                is_last_price: contact.is_last_price || 0,
                is_h5_short_url: contact.is_h5_short_url || 0,
                is_stock: contact.is_stock || '1',
                is_4s_price: contact.is_4s_price || '0',
                reply_mode: contact.reply_mode || 'text',
                reply_time: contact.reply_time || "5",
                reply_ad: contact.reply_ad || '',
                subjectName: subjectName,
                customerName: customerName
              }
            })
          }
        } catch (error) {
          console.error(`获取${type}详细信息失败：`, error)
        }
      }
      
      return contacts
    },
    
    // 选择群聊
    selectGroupChat(group) {
      console.log("group",group)
      // 如果点击的是已选中的群聊，则取消选中并显示群聊列表
      if (this.selectedGroupChat && this.selectedGroupChat.chatroom_id === group.chatroom_id) {
        this.selectedGroupChat = null;
      } else {
        // 否则选中该群聊
        this.selectedGroupChat = group;
      }
    },
    
    // 保存群聊设置
    async saveGroupChatSettings() {
      if (!this.selectedGroupChat) return;
      console.log("saveGroupChatSettings",this.saveGroupChatSettings);
      console.log("wxid",this.settings);
      
    
      try {
        // 准备发送的数据
        const settingsToSend = {
          
          // 群聊设置需要带上群聊的 ID
          room_id: this.selectedGroupChat.chatroom_id,
          gewe_nickname: this.selectedGroupChat.remark || this.selectedGroupChat.nickName || this.selectedGroupChat.userName || this.selectedGroupChat.wxid,
          gewe_avatar: this.selectedGroupChat.smallHeadImgUrl,
          gewe_wxid: this.settings.gewe_wxid,
         
          price_roi: this.selectedGroupChat.price_roi,
          price_field: this.selectedGroupChat.price_field,
          last_price: this.selectedGroupChat.is_last_price == 1  ? JSON.stringify({
            customerName: this.selectedGroupChat.customerName,
            subjectName: this.selectedGroupChat.subjectName,
          }) : this.selectedGroupChat.is_last_price,
          is_stock: this.selectedGroupChat.is_stock,
          reply_mode: this.selectedGroupChat.reply_mode,
          reply_time: this.selectedGroupChat.reply_time,
          reply_ad: this.selectedGroupChat.reply_ad,
          is_4s_price: this.selectedGroupChat.is_4s_price,
          is_h5_short_url: this.selectedGroupChat.is_h5_short_url,
          set_number: this.selectedGroupChat.set_number,
          set_surplus: this.selectedGroupChat.set_surplus,
        };
        
        // 如果该群聊已有设置ID，则带上该ID
        if (this.selectedGroupChat.id) {
          settingsToSend.id = this.selectedGroupChat.id;
        }
        // 判断所有群聊set_number相加是否超过机器人总次数
        const totalSetNumber = this.groupChatList.filter(group => group.room_id!=this.selectedGroupChat.room_id).reduce((acc, group) => acc + group.set_number, 0);
        if (totalSetNumber+this.selectedGroupChat.set_number > this.settings.set_number) {
          this.$message.warning('群聊设置的总次数不能超过机器人的总次数')
          return
        }
        // 使用与机器人设置相同的接口保存群聊设置
        await this.$api.setWxRobots(settingsToSend)
        console.log('发送的群聊设置数据:', settingsToSend);
        this.$message.success('群聊设置保存成功')
        
        // 重新获取群聊列表以更新数据
        this.getGroupChatList()
      } catch (error) {
        console.error('保存群聊设置失败:', error)
        this.$message.error('保存群聊设置失败')
      }
    },
    
    // 删除群聊设置
    async deleteGroupChatSettings() {
      if (!this.selectedGroupChat || !this.selectedGroupChat.id) return;
      
      try {
        await this.$confirm('确定要删除该群聊设置吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用删除接口，使用与保存相同的接口，但传递一个特殊参数来标识删除操作
      
        await this.$api.delWxRobots({ id: this.selectedGroupChat.id });
        this.$message.success('群聊设置删除成功');
        
        // 清空选中的群聊
        this.selectedGroupChat = null;
        
        // 重新获取群聊列表以更新数据
        this.getGroupChatList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除群聊设置失败:', error);
          this.$message.error('删除群聊设置失败');
        }
      }
    },
    
   
    
    // 处理 tab 切换
    handleTabClick(tab) {
      if (tab.name === 'groupChats') {
        // 切换到群聊设置 tab 时，根据当前选中的机器人获取对应的群聊列表
        this.getGroupChatList();
      } else if (tab.name === 'countRecord') {
        // 切换到次数记录 tab 时，根据当前选中的机器人获取对应的次数记录
        if (this.settings && this.settings.id) {
          this.getCountRecords(this.settings.id);
        }
      }
    },
    
    // 保存设置
    async saveSettings(){
      // 检查是否是新增用户
      
      
      // 检查周期时间范围是否已选择
      if (this.settings.set_meal === 'lCount' && 
        (!this.settings.cycleTimeRange || this.settings.cycleTimeRange.length !== 2)) {
        this.$message.warning('请选择周期时间范围')
        return
      }
      let res = await this.$apiGewe.getWxInfo({
        token: this.settings.gewe_token,
        appId: this.settings.gewe_device_id
      })
      console.log("res",res.data);
      
      try {
        console.log("this.settings",this.settings);
        // last_price: this.settings.is_last_price != 0 && this.settings.is_last_price != 2 ? JSON.stringify({
        //     customerName: this.settings.customerName,
        //     subjectName: this.settings.subjectName,
        //   }) : this.settings.is_last_price,
        // 准备发送的数据
        const settingsToSend = {
          ...this.settings,
          gewe_nickname:res.data.nickName,
          gewe_avatar:res.data.bigHeadImgUrl,
          gewe_wxid:res.data.wxid,
          set_extend: this.settings.set_meal == 'lCount'?JSON.stringify({
            startTime: this.settings.cycleTimeRange[0],
            endTime: this.settings.cycleTimeRange[1]
          }):"",
          
          stat_account: JSON.stringify({
            shop_id: this.selectedShopPartId || '1780',
            store_id: this.selectedCustomerId || this.$store.state.store_id,
            store_name: this.selectedCustomerDisplay ? this.selectedCustomerDisplay.company_name : this.$store.state.store_name,
            member_id: this.selectedEmployeeId.includes("-") ? this.selectedEmployeeId  : this.selectedCustomerId+"-"+this.selectedEmployeeId,
            member_name: this.selectedEmployeeDisplay ? this.selectedEmployeeDisplay.nickname : this.$store.state.nickname,
          }),
          store_id: this.selectedCustomerId || this.$store.state.store_id,
          is_4s_price: this.settings.is_4s_price
        };
        
        // 检查套餐类型是否发生改变
        if (this.originalSetMeal && this.originalSetMeal !== this.settings.set_meal) {
          settingsToSend.set_surplus = 0;
        }
        
        // 模拟接口调用，后续需要替换成真实接口
        await this.$api.setWxRobots(settingsToSend)
        console.log('发送的设置数据:', settingsToSend);
        this.$message.success('设置保存成功')
        
        // 检查套餐或次数是否发生变化，如果变化则保存记录
        const hasMealOrCountChanged = (
          this.originalSetMeal !== this.settings.set_meal || 
          this.originalSetNumber !== this.settings.set_number || 
          this.originalSetSurplus !== this.settings.set_surplus
        );
        
        if (hasMealOrCountChanged) {
          try {
            // 获取用户信息
            const statAccount = typeof this.settings.stat_account === 'string' 
              ? JSON.parse(this.settings.stat_account) 
              : this.settings.stat_account;
            
            // 调用记录接口保存信息
            await this.$api.set_record({
              total: this.settings.set_number, // 总次数
              number: this.settings.set_surplus, // 已使用次数
              robots_id: this.settings.id, // 当前机器人的id
              member_id: this.$store.state.member_id|| statAccount?.member_id  , // 用户的member_id
              member_name: this.$store.state.member_name || statAccount?.member_name  // 用户的member_name
            });
            
            console.log('次数记录保存成功');
          } catch (recordError) {
            console.error('保存次数记录失败:', recordError);
            this.$message.warning('次数记录保存失败，但设置已保存');
          }
        }
        
        this.getUserList()
      } catch (error) {
        console.error('保存设置失败:', error)
        this.$message.error('保存设置失败')
      }
      
    },
    
    // 获取次数记录列表
    async getCountRecords(robotId) {
      if (!robotId) {
        console.warn('未传入机器人ID，无法获取次数记录');
        return;
      }
      
      this.recordListLoading = true;
      try {
        // 调用接口获取次数记录列表
        const response = await this.$api.get_record({
          robots_id: robotId
        });
        
        // 更新次数记录列表
        this.countRecords = response || [];
      } catch (error) {
        console.error('获取次数记录失败:', error);
        this.$message.error('获取次数记录失败');
        this.countRecords = [];
      } finally {
        this.recordListLoading = false;
      }
    },
    
    // 格式化日期时间
    formatDate(timestamp) {
      if (!timestamp) return '';
      
      const date = new Date(timestamp * 1000); // 假设时间戳是秒级的
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // 处理新增用户
    async handleAddUser() {
      try {
        // 这里应该调用新增用户的接口
        // 模拟新增用户逻辑
        const newUser = {
          
          nickname: '新微信' + (this.userList.filter(u => !u.isNew).length + 1),
          
         
          gewe_token: this.settings.gewe_token,
          gewe_device_id: this.settings.gewe_device_id
        };
        
        // 添加到用户列表
        this.userList.splice(this.userList.length - 1, 0, newUser); // 插入到新增项之前
        
        // 选中新增的用户
        this.selectUser(newUser);
        
        this.$message.success('新增用户成功');
      } catch (error) {
        console.error('新增用户失败:', error);
        this.$message.error('新增用户失败');
      }
    }
  },
  async created(){
    await this.getUserList()
    if(this.$store.state.store_id!=1780&&this.$store.state.store_id!=1989){
      let user = this.userList.find(u => u.stat_account.includes(this.$store.state.store_id))
      await this.selectUser(user)
      this.activeTab = 'groupChats'
      await this.getGroupChatList();

    }
  }
}
</script>

<style lang="scss">
.wx-jqr {
  padding: 20px;
  background: #fff;
  
  .user-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    
    .user-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding: 10px;
      border-radius: 8px;
      position: relative;
      
      &:hover {
        background-color: #f5f5f5;
      }
      
      &.active {
        background-color: #e6f7ff;
        border: 1px solid #1890ff;
      }
      
      &.new-user {
        border: 1px dashed #1890ff;
        color: #1890ff;
        
        .user-name {
          font-weight: bold;
        }
      }
      
      .user-name {
        margin-top: 8px;
        font-size: 14px;
      }
      
      .avatar-container {
        position: relative;
        
        .delete-btn {
          position: absolute;
          top: -8px;
          right: -8px;
          width: 20px;
          height: 20px;
          padding: 0;
          display: none;
        }
      }
      
      &:hover .delete-btn {
        display: block;
      }
    }
  }
  
  .settings-form {
    h3 {
      margin-bottom: 20px;
      color: #333;
    }
    
    .el-tabs {
      .el-tabs__header {
        margin-bottom: 20px;
      }
    }
    
    .el-form-item {
      margin-bottom: 20px;
      
      label {
        font-weight: bold;
      }
    }
    
    .el-select, .el-input-number, .el-date-editor {
      margin-right: 10px;
    }
    
    .package-settings {
      padding: 15px 0;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      margin-bottom: 20px;
      
      .el-form-item {
        margin-bottom: 15px;
      }
    }
    
    .selected-customer, .selected-employee, .selected-shop-part {
      margin-top: 10px;
      padding: 5px;
      background-color: #f0f9eb;
      border: 1px solid #e1f3d8;
      border-radius: 4px;
      color: #67c23a;
    }
    
    .customer-id {
      color: #999;
      font-size: 12px;
    }
    
    // 群聊列表样式
    .group-chat-list {
      display: flex;
      flex-wrap: wrap;
      gap: 15px;
      margin-bottom: 20px;
      max-height: 300px;
      overflow-y: auto;
      
      .group-chat-item {
        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        width: calc(50% - 10px);
        
        &:hover {
          background-color: #f5f5f5;
        }
        
        &.active {
          background-color: #e6f7ff;
          border-color: #1890ff;
        }
        
        .group-info {
          margin-left: 10px;
          
          .group-name {
            font-size: 14px;
            color: #333;
          }
        }
      }
    }
    
    // 群聊设置样式
    .group-chat-settings {
      padding: 20px;
      border: 1px solid #ddd;
      border-radius: 4px;
      
      h4 {
        margin-bottom: 15px;
        color: #333;
      }
    }
    
    .no-data {
      text-align: center;
      color: #999;
      padding: 20px;
    }
  }
}
</style>